<template>
  <section>
    <b-tabs v-model="activeTab">
      <!-- <b-tab-item label="Applications">
        Applications
      </b-tab-item> -->
      <b-tab-item label="Profiles">
        <b-table className="table" :data="missionGoersArray" striped>
          <template slot-scope="props">
            <b-table-column field="name" label="Is Approved?">
              <b-field>
                <b-checkbox v-model="props.row.missionGoerInfo.approved"
                  true-value="Yes"
                  false-value="No"
                >
                </b-checkbox>
              </b-field>
            </b-table-column>
            <b-table-column field="name" label="Name">
              {{ props.row.userProfile.name }}
            </b-table-column>
            <b-table-column field="biography" label="Biography" width="120">
              {{ props.row.userProfile.biography }}
            </b-table-column>
            <b-table-column field="degree" label="Degree" width=100>
              {{ props.row.userProfile.degrees }}
            </b-table-column>
            <b-table-column field="occupation" label="Occupation">
              {{ props.row.userProfile.occupation }}
            </b-table-column>
            <b-table-column field="email" label="Email">
              {{ props.row.userProfile.email }}
            </b-table-column>
            <b-table-column field="cell-phone" label="Cell Phone">
              {{ props.row.userProfile.phoneMobile }}
            </b-table-column>
            <b-table-column field="address" label="Address" width=200>
              {{ props.row.userProfile.workAddress }}
            </b-table-column>
            <b-table-column field="notes" label="Notes">
              <b-input
                type="textarea"
                v-model="props.row.userProfile.notes.profile"
              ></b-input>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item label="Documents">
        <b-table className="table" :data="missionGoersArray" striped>
          <template slot-scope="props">
            <b-table-column field="name" label="Name">
              {{ props.row.userProfile.name }}
            </b-table-column>
            <b-table-column field="passport" label="Passport">
              <div v-if="props.row.userProfile.passport.key">
                <FileViewer
                  :s3UploadKey=props.row.userProfile.passport.key
                  :userId=props.row.userId
                  :btnViewText="props.row.userProfile.passport.key.split('--')[1]"
                />
              </div>
            </b-table-column>
            <b-table-column field="diplomas" label="Diplomas">
              <div class="view-div" v-for="diploma in props.row.userProfile.diplomas">
                <div v-if="diploma.key">
                  <FileViewer
                    :s3UploadKey=diploma.key
                    :userId=props.row.userId
                    :btnViewText="diploma.key.split('--')[1]"
                  />
                </div>
              </div>
            </b-table-column>
            <b-table-column field="stateLicenses" label="State Licenses">
              <div class="view-div" v-for="license in props.row.userProfile.stateLicenses">
                <div v-if="license.key !== null">
                  <FileViewer
                    :s3UploadKey=license.key
                    :userId=props.row.userId
                    :btnViewText="license.key.split('--')[1]"
                  />
                </div>
              </div>
            </b-table-column>
            <b-table-column field="resume" label="Resume">
              <div v-if="props.row.userProfile.resume.key">
                <FileViewer
                  :s3UploadKey=props.row.userProfile.resume.key
                  :userId=props.row.userId
                  :btnViewText="props.row.userProfile.resume.key.split('--')[1]"
                />
              </div>
            </b-table-column>
            <b-table-column field="notes" label="Notes">
              <b-input
                type="textarea"
                v-model="props.row.userProfile.notes.documents"
              >
              </b-input>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item label="Travel">
        <b-table className="table" :data="missionGoersArray" striped>
          <template slot-scope="props">
            <b-table-column field="name" label="Name">
              {{ props.row.userProfile.name }}
            </b-table-column>
            <b-table-column field="scrubTop" label="Scrub Top">
              <b>{{props.row.missionGoerInfo.scrubTopSize}}</b>
            </b-table-column>
            <b-table-column field="scrubBottom" label="Scrub Bottom">
              <b>{{props.row.missionGoerInfo.scrubBottomSize}}</b>
            </b-table-column>
            <b-table-column field="city" label="City">
            </b-table-column>
            <b-table-column field="flightItinerary" label="Flight Itinerary">
            </b-table-column>
            <b-table-column field="visa" label="Visa">
            </b-table-column>
            <b-table-column field="vaccinations" label="Vaccinations">
              <div v-for="vaccineName in Object.keys(props.row.missionGoerInfo.vaccineDates)">
                <b>{{ vaccineName }}:</b>
                {{ new Date(props.row.missionGoerInfo.vaccineDates[vaccineName]).toLocaleDateString()}}
              </div>
            </b-table-column>
            <b-table-column field="travelInsurance" label="Travel Insurance">
            </b-table-column>
            <b-table-column field="notes" label="Notes">
              <b-input
                type="textarea"
                v-model="props.row.userProfile.notes.travel"
              ></b-input>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>

    </b-tabs>
  </section>
</template>

<script>

import _ from 'lodash';
import ApiUtil from '../../utils/ApiUtil';
import FileViewer from '@/components/FileViewer';

export default {
  async created() {
    const { missionId } = this.$route.params;
    const mission = await ApiUtil.getMission(missionId);
    const allUsers = await ApiUtil.getUsers();
    const userIdToProfile = {};
    allUsers.forEach((userProfile) => {
      const userId = userProfile.userId;
      delete userProfile.userId;
      userIdToProfile[userId] = this.getFormattedUserProfile(userProfile);
    });
    if (_.get(mission, 'missionGoers')) {
      const missionGoersArray = Object.keys(mission.missionGoers).map((userId) => {
        const updatedMission = {};
        updatedMission.missionGoerInfo = this.getFormattedMissionGoerInfo(mission.missionGoers[userId]);
        updatedMission.userId = userId;
        updatedMission.userProfile = userIdToProfile[userId];
        return updatedMission;
      });
      this.missionGoersArray = missionGoersArray;
    }
  },
  components: {
    FileViewer,
  },
  data() {
    return {
      missionId: this.$route.params.missionId,
      missionGoersArray: [],
      activeTab: 0,
    };
  },
  methods: {
    getFormattedUserProfile(userProfile) {
      const updatedUserProfile = {};
      updatedUserProfile.name = `${_.get(userProfile, 'firstName', 'N/A')} ${_.get(userProfile, 'lastName', '')}`;
      updatedUserProfile.degrees = _.get(userProfile, 'degrees', []).join(',');
      updatedUserProfile.occupation = _.get(userProfile, 'occupation', 'N/A');
      updatedUserProfile.email = _.get(userProfile, 'email', 'N/A');
      updatedUserProfile.phoneMobile = _.get(userProfile, 'phoneMobile', 'N/A');
      updatedUserProfile.workAddress = `${_.get(userProfile, 'workName', 'N/A')},${
        _.get(userProfile, 'workStreet1', '')
      },${_.get(userProfile, 'workStreet2', '')
      },${_.get(userProfile, 'workCity', '')
      },${_.get(userProfile, 'workState', '')
      } ${_.get(userProfile, 'workZip', '')}`;

      updatedUserProfile.biography = _.get(userProfile, 'biography', 'N/A');
      updatedUserProfile.passport = _.get(userProfile, 'uploads.passport', { key: null, dateUploaded: null });
      updatedUserProfile.diplomas = _.get(userProfile, 'uploads.diplomas', []);
      updatedUserProfile.stateLicenses = _.get(userProfile, 'uploads.stateLicenses', []);
      updatedUserProfile.resume = _.get(userProfile, 'uploads.resume', { key: null, dateUploaded: null });
      updatedUserProfile.notes = {
        documents: '',
        profile: '',
        travel: '',
      };
      return updatedUserProfile;
    },
    getFormattedMissionGoerInfo(goer) {
      const updatedMissionGoerInfo = {};
      updatedMissionGoerInfo.scrubTopSize = goer.scrubTopSize ? goer.scrubTopSize.toUpperCase() : 'N/A';
      updatedMissionGoerInfo.scrubBottomSize = goer.scrubBottomSize ? goer.scrubBottomSize.toUpperCase() : 'N/A';
      updatedMissionGoerInfo.vaccineDates = _.get(goer, 'vaccineDate', {});
      return updatedMissionGoerInfo;
    },
  },
};
</script>

<style lang="scss">
  @import '../../common/colors.scss';
  .parent-container {
    display: inline-block !important;
  }
  .content {
    display: flex;
  }
  .mission-goer-info {
    margin-left: 10px;
  }
  .mission-goer-table-key {
    font-weight: bold;
  }
  .icon-spacing {
    margin-left: 10px;
  }
  .view-div {
    margin-bottom: 10px;
  }
  .table {
    word-break:break-all;
  }
</style>
